var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlgoFavIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 282 281",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140.941 175.711C160.436 175.711 176.241 159.906 176.241 140.411C176.241 120.915 160.436 105.111 140.941 105.111C121.445 105.111 105.641 120.915 105.641 140.411C105.641 159.906 121.445 175.711 140.941 175.711Z",
    fill: "#33CC00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M245.843 70.8109C265.339 70.8109 281.143 55.0066 281.143 35.5109C281.143 16.0153 265.339 0.210938 245.843 0.210938C226.347 0.210938 210.543 16.0153 210.543 35.5109C210.543 55.0066 226.347 70.8109 245.843 70.8109Z",
    fill: "#33CC00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M245.843 280.611C265.339 280.611 281.143 264.807 281.143 245.311C281.143 225.815 265.339 210.011 245.843 210.011C226.347 210.011 210.543 225.815 210.543 245.311C210.543 264.807 226.347 280.611 245.843 280.611Z",
    fill: "#33CC00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M140.941 70.8109C160.436 70.8109 176.241 55.0066 176.241 35.5109C176.241 16.0153 160.436 0.210938 140.941 0.210938C121.445 0.210938 105.641 16.0153 105.641 35.5109C105.641 55.0066 121.445 70.8109 140.941 70.8109Z",
    fill: "#013B72"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M140.941 280.611C160.436 280.611 176.241 264.807 176.241 245.311C176.241 225.815 160.436 210.011 140.941 210.011C121.445 210.011 105.641 225.815 105.641 245.311C105.641 264.807 121.445 280.611 140.941 280.611Z",
    fill: "#013B72"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0422 175.711C55.5378 175.711 71.3422 159.906 71.3422 140.411C71.3422 120.915 55.5378 105.111 36.0422 105.111C16.5465 105.111 0.742188 120.915 0.742188 140.411C0.742188 159.906 16.5465 175.711 36.0422 175.711Z",
    fill: "#013B72"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlgoFavIcon);
export default __webpack_public_path__ + "static/media/AlgoFavIcon.589d7d7e3a301813abdc1120250df48b.svg";
export { ForwardRef as ReactComponent };